import routePerformanceComponent from "./route_performance.component";

let routePerformanceModule = angular.module('routePerformance', [])
    .component('routePerformance', routePerformanceComponent)
    .name;

export default routePerformanceModule;



// WEBPACK FOOTER //
// ./client/app/components/reporting/components/route_performance/index.js